import { ON_FULFILLMENT_OFFERINGS_SUCCESS } from '../../action-types';
import { getCartReviewsItemsFromPayload, getAppliedPromoIdsFromCartReviewsItems } from './utils';

export default function promosReducer(state = {}, action = {}) {
  switch (action.type) {
    case ON_FULFILLMENT_OFFERINGS_SUCCESS: {
      const cartReviewsItem = getCartReviewsItemsFromPayload(action.payload);

      return { ...state, appliedPromoIds: getAppliedPromoIdsFromCartReviewsItems(cartReviewsItem) };
    }
    default:
      return state;
  }
}
